import { queryDataExt } from "../BaseService/index";
const GlobalConfig = new window.globalConfig();

export const getBasePricesWithConditions = async (
  whereClause,
  selectFields,
  sortFields
) => {
  return await queryDataExt(
    `${GlobalConfig.REACT_APP_API_BASEPRICE_URL}getWithConditions`,
    whereClause,
    selectFields,
    sortFields
  );
};
